const CONSTANTS = {
	JSON_URL: import.meta.env.VITE_JSON_URL || "",
	ENV: import.meta.env.VITE_ENVIRONMENT || "",
	BASE_DOMAIN: import.meta.env.VITE_BASE_DOMAIN || "",
	BASE_URL: import.meta.env.VITE_BASE_URL || "",
	PROJECT_SITE_UTL: import.meta.env.VITE_LINK || "",
	FB_SHARE_URL: import.meta.env.VITE_FB_SHARE_URL || "",
	MOBILE_SIZE_QUERY: "(max-width: 880px)",
	MAIN_PLAY_HREF: `${import.meta.env.VITE_BASE_DOMAIN || ""}/play`,
	MAIN_ACCOUNT_HREF: `${import.meta.env.VITE_BASE_DOMAIN || ""}`,
	IS_OFF_SEASON: JSON.parse(import.meta.env.VITE_OFFSEASON_STATE || "false") as boolean,
	BADGE_URL: import.meta.env.VITE_BADGE_URL || "",
	BETTING_COUNTRIES: ["US"],
	BETTING_STATES: ["ON"],
	SITE_URL: window.location.origin || "",
	SKIP_TRANSLATIONS:
		new URLSearchParams(window.location.search).get("skipTranslation") === "true",
	GAME_ID: "BeatTheStreak2022",
	EXIT_URL: "https://www.mlb.com/play",
	PRIZE_WEEKLY_DISABLE: import.meta.env.VITE_PRIZE_WEEKLY_DISABLE === "true",
};

export default CONSTANTS;
